import { NgModule } from '@angular/core';
import {NcFormContentComponent} from './nc-form-content/nc-form-content.component';
import {NcFormTitleComponent} from './nc-form-title/nc-form-title.component';
import {TranslateModule} from '@ngx-translate/core';
import {MatCardModule} from '@angular/material/card';



@NgModule({
  declarations: [NcFormContentComponent, NcFormTitleComponent],
  imports: [
    TranslateModule,
    MatCardModule
  ],
  exports: [NcFormContentComponent, NcFormTitleComponent]
})
export class NcFormModule { }
